export type Event = null | ChestEvent | MeerkatEvent;

export type ChestEvent = {
  type: 'chest';
};

export type MeerkatEvent = {
  type: 'meerkat';
};

export const isChestEvent = (event: Event): event is ChestEvent => event?.type === 'chest';
export const isMeerkatEvent = (event: Event): event is MeerkatEvent => event?.type === 'meerkat';
